// 平台船运需求

import UltMeta, { Meta } from "./UltMeta/index";

class State extends UltMeta {
    TO_BE_PUBLISH = new Meta(0, "待发布");
    TO_BE_ALLOCATED = new Meta(1, "已发布");
    ENDED = new Meta(2, "已结束");
    CLOSED = new Meta(3, "已关闭");
    TO_BE_CONFIRMED = new Meta(4, "待确认");
}

export const STATE = new State();

/**
 * 接单状态
 */
class OrderAcceptanceState extends UltMeta {
    PENDING_PROCESSING = new Meta(0, "待处理");
    CONFIRMED = new Meta(1, "--");
}

export const ORDER_ACCEPTANCE_STATE = new OrderAcceptanceState();

/**
 * 排水槽
 */
class DrainageChannel extends UltMeta {
    NO_DRAINAGE_CHANNEL = new Meta(1, "无水槽");
    DRAINAGE_CHANNEL_FAIR = new Meta(2, "水槽一般");
    DRAINAGE_CHANNEL_GOOD = new Meta(3, "水槽好");
}
export const DRAINAGE_CHANNEL = new DrainageChannel();

/**
 * 船务小程序船运需求标签
 */
class RouteTag extends UltMeta {
    SMART_MATCH = new Meta(1, "智能匹配");
    FREQUENT_ROUTE = new Meta(2, "常跑航线");
    HISTORICAL_ROUTE = new Meta(3, "历史航线");
}

export const ROUTE_TAG = new RouteTag();

/**
 * 电联号码类型
 */
class ElectricContactNumberType extends UltMeta {
    PHONE = new Meta(1, "手机号");
    LANDLINE = new Meta(2, "座机");
}

export const ELECTRIC_CONTACT_NUMBER_TYPE = new ElectricContactNumberType();

/**
 * 数据来源
 */
class DataSourceType extends UltMeta {
    INNER = new Meta(1, "平台船运需求");
    OUTER = new Meta(2, "三方需求");
    INNER_AUTO = new Meta(3, "平台船运需求(自动)");
}

export const DATE_SOURCE_TYPE = new DataSourceType();

/**
 * 需求等级
 * */
class DemandLevel extends UltMeta {
    ONE = new Meta(1, "1级", "info");
    TWO = new Meta(2, "2级", "success");
    THREE = new Meta(3, "3级", "primary");
    FOUR = new Meta(4, "4级", "warning");
    FIVE = new Meta(5, "5级", "danger");
}

export const DEMAND_LEVEL = new DemandLevel();
// 船运需求-取消类型
class CancelType extends UltMeta {
    AGENT_CANCEL = new Meta(1, "货主取消需求");
    PLAT_CANCEL = new Meta(2, "平台取消需求");
}
export const CANCEL_TYPE = new CancelType();
